/**
 * Section.tsx — 卡片容器（标题 + 副标题 + 右上 action）
 *
 * 移植自原型 design/Novel-admin/src/primitives.jsx 的 Section，合并 apps / books / ops / profile 各页用法。
 * pad / headPad 还原各处历史内边距；JSX/className/inline-style 与蓝本 1:1。
 */

import type { ReactNode } from 'react';

export function Section({
  title,
  sub,
  children,
  action,
  pad = '4px 18px 14px',
  headPad = '12px 0',
}: {
  title: ReactNode;
  sub?: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  pad?: string;
  headPad?: string;
}) {
  return (
    <div className="card" style={{ padding: pad }}>
      <div
        style={{
          padding: headPad,
          borderBottom: '1px solid var(--border)',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 500, fontSize: 13.5 }}>{title}</div>
          {sub && (
            <div style={{ fontSize: 11.5, color: 'var(--fg-muted)', marginTop: 2 }}>{sub}</div>
          )}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}
